// @flow
import { css } from "styled-components";

import { smallHeading } from "../../components/Typography/Headings";
import { mediumParagraph } from "../../components/Typography/Paragraphs";

export type Props = {|
  buyingButtonLabel?: string,
  buyingButtonLink?: PrismicLink,
  buyingImage?: PrismicImage,
  buyingText?: string,
  buyingTitle?: string,
  sellingButtonLabel?: string,
  sellingButtonLink?: PrismicLink,
  sellingImage?: PrismicImage,
  jointImage?: PrismicImage,
  sellingText?: string,
  sellingTitle?: string,
|};

export const getFirstWord = (string?: string = "") => string.split(" ")[0];
export const getTextWithoutFirstWord = (string?: string = "") =>
  string.split(" ").slice(1).join(" ");

export const textStyles = css`
  width: 100%;

  h3 {
    ${smallHeading}
    margin-bottom: 0;
    margin-top: 0;
  }

  p {
    ${mediumParagraph}
    margin-top: 10px;
    margin-bottom: 0;

    span {
      font-weight: 500;
    }
  }
`;
